import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import authContext from "../context/authContext/authContext";
import ClaimerModal from "./modals/ClaimerModal";
import { checkAuthPage } from "../utils/utils";
import { getUserAction } from "../redux/actions/userAction";
import RatingModal from "./modals/RatingModal";

const NavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { user, logout, getConfig } = useContext(authContext);
  const config = getConfig();


  const getUser = () => {
    dispatch(getUserAction(config))
  }

  useEffect(() => {
    if (
      !user &&
      pathname !== "/login" &&
      pathname !== "/register" &&
      pathname === "/register"
    ) {
      window.location.href = "/login";
    } else if (user) {
      getUser();
    }
  }, [user?._id]);


  const intialState = {
    isMobileNav: false,
    isPartnerClicked: false,
    isUserOptionsClicked: false,
  };
  const [state, setCompleteState] = useState(intialState);
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));
  const { user: currentUser } = useSelector((state) => state.user);

  const isAuthPage = checkAuthPage(pathname)

  useEffect(() => {
    setState(intialState);
  }, [pathname]);

  if (isAuthPage) {
    return <></>;
  }

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const renderClassName = (pathName) => {
    let className = "nav-link";
    if (pathName === pathname) {
      className += " active";
    }
    return className;
  };

  return (
    <>
      <header id="header" className="fixed-top d-flex align-items-center">
        <div className="container d-flex align-items-center justify-content-between">
          <div className="logo">
            <Link to="/">
              <img
                src="assets/img/gleamDesk.png"
                alt=""
                className="img-fluid nav-logo"
              />
            </Link>
          </div>
          <nav
            id="navbar"
            className={`navbar ${state.isMobileNav ? " navbar-mobile" : ""}`}
          >
            <ul>
              <li>
                <Link className={renderClassName("/")} to="/">
                  Home{" "}
                </Link>
              </li>
              <li>
                <Link className={renderClassName("/about")} to="/about">
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  className={renderClassName("/appointments")}
                  to="/appointments"
                >
                  Appointents
                </Link>
              </li>
              {/* <li>
              <Link className={renderClassName("/partners")} to="/partners">
                Partners
              </Link>
            </li> */}
              <li>
                <Link className={renderClassName("/products")} to="/products">
                  Products
                </Link>
              </li>
              <li>
                <Link
                  className={renderClassName("/contact")}
                  to="/contact"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  className={renderClassName("/claimer")}
                  onClick={() => setState({ showClaimer: true })}
                >
                  Claimer
                </Link>
              </li>
              {currentUser?.referId && !currentUser?.partnerRating && (
                <li>
                  <Link
                    className={renderClassName("/rating")}
                    onClick={() => setState({ showRatingModal: true })}
                  >
                    Rating
                  </Link>
                </li>
              )}
              {/* <li>
                <Link to="/demat" className={`nav-link ${pathname === "/demat" ? "active" : ""}`}>
                  DEMAT
                </Link>
              </li> */}
              <li className="dropdown">
                <Link
                  onClick={() => setState({ isUserOptionsClicked: !state.isUserOptionsClicked })}
                  className={`nav-link ${pathname === "/profile" || pathname === "/gdtokens"
                    ? "active"
                    : ""
                    }`}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <div>
                      <img
                        src={currentUser?.imageUrl}
                        className="img-user-navbar"
                        alt="profile-image"
                      />
                    </div>
                    <div>
                      <span className="user-name">{currentUser?.name}</span>{" "}
                      <i className="bi bi-chevron-down" />
                    </div>
                  </div>
                </Link>
                <ul className={state.isMobileNav && state?.isUserOptionsClicked ? "dropdown-active" : ""}>
                  <li style={{ marginBottom: -10 }}>
                    <Link
                      to="/gt"
                      className={renderClassName("/gdtokens")}
                    >
                      <span>GT: {currentUser?.gdTokens || 0}
                        <span style={{ zoom: 0.08, position: 'relative', left: 100, bottom: 75 }}>
                          <img src="assets/img/gt-logo.png" />
                        </span>
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={renderClassName("/history")}
                      to="/history"
                    >
                      Account History
                    </Link>
                  </li>
                  {currentUser?.isPartner ? (
                    <li>
                      <Link className={renderClassName("/referrals")} to="/referrals">
                        <span>
                          Partner
                          <i className="micon fa fa-check text-success" style={{ fontSize: 15 }} />
                        </span>
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <Link
                        className={renderClassName("/partnership")}
                        to="/partnership"
                      >
                        Become Partner
                      </Link>
                    </li>
                  )}

                  <li>
                    <Link
                      className={renderClassName("/payouts")}
                      to="/payouts"
                    >
                      Payouts
                    </Link>
                  </li>

                  <li>
                    <Link
                      className={renderClassName('/profile')}
                      to="/profile"
                    >
                      Edit profile
                    </Link>
                  </li>
                  <li onClick={handleLogout}>
                    <Link className="nav-link btn btn-logout">Logout</Link>
                  </li>
                </ul>
              </li>
            </ul>
            <i
              className="bi bi-list mobile-nav-toggle"
              onClick={() => setState({ isMobileNav: !state.isMobileNav })}
            />
          </nav>
        </div>
      </header>

      <ClaimerModal
        isOpen={state.showClaimer}
        toggle={() => setState({ showClaimer: false })}
      />

      <RatingModal
        isOpen={state.showRatingModal}
        toggle={() => setState({ showRatingModal: false })}
        getUser={getUser}
      />
    </>
  );
};

export default NavBar;
